import React from "react"
import _ from "lodash"

import { useBet } from "@root/bet_utils/context/bet"
import BetStatus from '@root/bet_utils/BetStatus'

export const Wrapper: React.FC = ({ children }) => <div className="textSelectionBet__wrapper">{children}</div>
export const Body: React.FC = ({ children }) => <div className="textSelectionBet__body">{children}</div>
export const Footer: React.FC = ({ children }) => <div className="textSelectionBet__footer">{children}</div>

export const Header: React.FC = () => {
  const bet = useBet() as TextSelection.Api.Bet

  return <div className="textSelectionBet__header">
    <h4>{bet.event_name}</h4>
    <BetStatus />
  </div>
}
